// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__2LvLv","logoBox":"Navbar_logoBox__7WvNE","logoText":"Navbar_logoText__b5Rc5","HomeButton":"Navbar_HomeButton__enebF"};